import {LOGO_URL} from "../utils/constants";
import {useState, useContext} from "react";
import { Link } from "react-router";
import useOnlineStatus from "../utils/useOnlineStatus";
import UserContext from "../utils/userContext";
import { useSelector } from "react-redux";


const Header = () => {

    // let btnName = "Login"; //we are trying with HTML

    //useState variable
    const [btnNameReact, setBtnNameReact] = useState("Login");
//We have created a global data inside the UserContext and thus for using that
//we are using a hook below and passing UserContext data.    
    const data = useContext(UserContext);

    //Subscribing to the store using a selector
    const cartItems = useSelector((store)=> store.cart.items );

    const onlinestatus = useOnlineStatus();
    return (
        <div className = "flex justify-between items-center bg-white shadow-md py-4 px-6 sticky  top-0 z-50">
            {/* Logo */}
            <div className = "logo-container">
                <img className = "w-32 hover:scale-105 transition-transform duration-300" src = {LOGO_URL} />
            </div>
        {/* Navigation */}
        <div className = "flex items-center space-x-6 text-lg text-gray-700">
            <ul className = "flex p-4 m-4">
                <li className="px-2">
                    Online Status : {onlinestatus ? "🟢" : "😡"} 
                </li>
                <li className="px-2 hover:text-blue-500 transition-colors duration-300">
                    <Link to = "/" >Home</Link></li>
                <li className="px-2 hover:text-blue-500 transition-colors duration-300">
                    <Link to = "/About" >About Us</Link>
                </li >
                <li className="px-2 hover:text-blue-500 transition-colors duration-300">
                    <Link to = "/contact" >Contact Us</Link>
                </li>
                <li className="px-2 hover:text-blue-500 transition-colors duration-300">
                    <Link to = "/Grocery" >Grocery</Link>
                </li>
                <li className="px-2 hover:text-blue-500 transition-colors duration-300">
                <Link to = "/Cart" >Cart ({cartItems.length} items)</Link>
                 
                </li>
                <div className = "flex items-center space-x-4">
                {/* <button className = "login" 
                onClick={()=>{btnName = "Logout"}}>{btnName}</button> */}
                <button className = "login bg-blue-500 text-white py-2 px-4 rounded-lg shadow-md hover:bg-blue-600 transition-colors duration-300" 
                onClick={()=>{
                    btnNameReact === "Login" ? setBtnNameReact("Logout") : setBtnNameReact("Login");
                }}>{btnNameReact}</button> 
               <li className="px-2 text-gray-600 font-semibold">{data.loggedInUser}</li>
               </div>
            </ul>
        </div>
        </div>
    )
}


export default Header;